module.exports = __webpack_public_path__ + "img/25. Nayantara Siruguri.2df9db15.jpg";